export const CHOOSE_DATE = 'Choose Date';
export const CHOOSE_DOCTOR = 'Choose Your Doctor';
export const CHOOSE_LOCATION = 'Choose Location';
export const CHOOSE_PREFIX = 'Choose Prefix';
export const CHOOSE_ROLE = 'Choose Role';
export const CHOOSE_SALUTATION = 'Choose Salutation';
export const CHOOSE_SITE = 'Choose Site';
export const CHOOSE_SUFFIX = 'Choose Suffix';
export const CHOOSE_TIME = 'Choose Time';
export const ENTER_EMAIL_ADDRESS = 'Enter Email Address';
export const ENTER_PHONE_NUMBER = 'Enter Phone Number';
export const FIRST_NAME_REQUIRED = 'First Name Required';
export const INCORRECT_CREDENTIALS = 'Incorrect Credentials or User Not Enabled';
export const INVALID_DATE = 'Invalid Date';
export const INVALID_DOCTOR = 'Invalid Doctor';
export const INVALID_EMAIL_ADDRESS = 'Invalid Email Address';
export const INVALID_LOCATION = 'Invalid Location';
export const INVALID_PHONE_NUMBER = 'Invalid Phone Number';
export const INVALID_ROLE = 'Invalid Role';
export const INVALID_SALUTATION = 'Invalid Salutation';
export const INVALID_TIME = 'Invalid Time';
export const LAST_NAME_REQUIRED = 'Last Name Required';
export const MIDDLE_NAME_REQUIRED = 'Middle Name Required';
export const MUST_BE_20_CHARACTERS_OR_LESS = 'Must be 20 characters or less'; // db
export const MUST_BE_250_CHARACTERS_OR_LESS = 'Must be 250 characters or less'; // db
export const MUST_BE_30_CHARACTERS_OR_LESS = 'Must be 30 characters or less'; // db
export const MUST_BE_50_CHARACTERS_OR_LESS = 'Must be 50 characters or less'; // db
export const MUST_BE_A_NUMBER = 'Must be a Number';
export const MUST_BE_A_CIDR = 'Must be a CIDR';
export const MUST_BE_AN_IP = 'Must be an IP address';
export const MUST_BE_EARLIER = 'Birth date should be earlier than Death date';
export const MUST_BE_IMAGE = 'You can only upload JPG/PNG file!';
export const MUST_BE_LESS_THAN_ONE_HUNDRED = 'Must be less than 100'; // db
export const MUST_BE_LESS_THAN_TEN = 'Must be less than 10'; // db
export const MUST_BE_POSITIVE = 'Must be positive';
export const MUST_BE_TWO_OR_GREATER = 'Must be 2 or greater'; // db
export const MUST_BE_UNIQUE = 'Must be Unique';
export const MUST_BE_ZERO_OR_GREATER = 'Must be 0 or greater'; // db
export const NO_PASSWORD_PROVIDED = 'No Password Provided';
export const PASSWORDS_MUST_MATCH = 'Passwords must match';
export const PASSWORD_CONFIRMATION_IS_REQUIRED = 'Password confirmation is required!';
export const PASSWORD_IS_TOO_SHORT = 'Password is too short - should be 6 chars minimum.'; // db
export const REQUIRED = 'Required';
export const SELECT_DATE = 'Select Date';
export const TOO_LONG = 'Too Long';
export const TOO_SHORT = 'Too Short';

export const mustBeBetweenNumberRange = (from: number, to: number): string => `Value must be between ${from} and ${to}`;
export const mustBeLessMb = (fileSize: number): string => `Must be smaller than ${fileSize}MB!`;
export const mustBeLessNumber = (number: number): string => `Must be less than ${number}.`;
export const mustBeGreaterNumber = (number: number): string => `Must be ${number} or greater.`;
export const mustBeThisCharactersOrLess = (number: number): string => `Must be ${number} characters or less.`;
export const passwordIsTooShort = (number: number): string => `Password is too short - should be ${
  number} chars minimum.`;
